<!--
 * @description: 
 * @Author: HaoJG
 * @Date: 2021-08-09 10:49:28
 * @Lasteditors: HaoJG
 * @LastEditTime: 2022-03-20 12:00:51
-->
<template>
    <div style='width:800px;left:50%;flex-grow:1;align-self:center'>
      <img src="/static/images/logo.png" alt="" style='width:200px;height:200px;'>
    <h2>{{webname}}</h2>
    </div>
    <!-- <div style='width:600px;position:relative;left:50%;'>
      <div v-for='(item,index) in sectionlist' :key='index' style='width:200px;height:200px;border:1px solid gray;border-radius:10px;'>
        {{item.title}}
      </div>
    </div> -->
</template>

<script>
export default {
  data() {
    return {
      webname:sessionStorage.getItem('webname'),
      sectionlist: JSON.parse(sessionStorage.getItem("sectionlist")),
    };
  },
  methods: {
    
  },
  created: function() {
  }
};
</script>
